var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29834 17.6799H18.2983M18.2983 13.6799V3.67993C18.2983 3.1495 18.0876 2.64079 17.7126 2.26572C17.3375 1.89065 16.8288 1.67993 16.2983 1.67993H4.29834C3.76791 1.67993 3.2592 1.89065 2.88413 2.26572C2.50905 2.64079 2.29834 3.1495 2.29834 3.67993V13.6799L6.29834 7.67993C8.96501 9.01327 11.6317 9.01327 14.2983 7.67993L18.2983 13.6799Z",
    stroke: "#4B5563",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheater);
export default __webpack_public_path__ + "static/media/theater.a47cc238becd4fa12a5319859716bd9b.svg";
export { ForwardRef as ReactComponent };